import CONSTANTS from './constants'
import browserUpdate from 'browser-update';
import preloader from './controller/preloader';
import footer from './controller/footer';
import {render} from './modules';
import faqArea from './controller/faq-area';
import file from './controller/file';
import header from './controller/header';
import popup from './controller/popup';
import prodAdd from './controller/prod-add';
import prodSlider from './controller/prod-slider';
import commentsList from './controller/popup-comments';
import slotMachine from './controller/slot-machine';
import orders from './controller/orders';
import datapickerRange from './controller/datapicker-range';
import drawer from './controller/drawer';
import statistics from './controller/statistics';
import popupCheck from './controller/popup-check';

preloader();
browserUpdate(CONSTANTS.browserUpdateOptions);

$(document).ready(() => {
  svg4everybody();
  render();
  footer();
  faqArea();
  file();
  header();
  popup();
  prodAdd();
  prodSlider();
  commentsList();
  slotMachine();
  orders();
  datapickerRange();
  drawer();
  statistics();
  popupCheck();
});
